import * as React from 'react'
import { HelpPanel, Icon } from '@amzn/awsui-components-react-v3';

export const infoPane = ( appearedTerms ) => {
  return (
    <HelpPanel
      header={<h3>Questionnaire</h3>}
      footer={
        <div>
          <h3>
            Learn more <Icon name="external" />
          </h3>
          <ul>
            <li>
              <a href="https://pathfinder.legal.amazon.dev/#/page/altarprogram-Products-CRIPT/live?container=altarprogram-Products-CRIPT-f6qvba8qhlju" target='_blank'>CRIPT FAQs</a>
            </li>
            <li>
              <a href="https://w.amazon.com/bin/view/CRIPTTool" target='_blank' >Export Compliance</a>
            </li>
          </ul>
        </div>
      }
    >
      <p>The answers to this questionnaire will help Export Compliance provide an Export Classification Number (“ECN”). In CRIPT, “ECN” is used as a general term encompassing both ECCN (under EAR) and ITAR classifications. In most cases, your export classification can be automatically derived based on your responses. Terms with additional information appear in blue in the questionnaire. Click on the term to view the additional information.</p>
      <br />
      <h3>Terms</h3>
      <dl>
        {appearedTerms && appearedTerms.length > 0 && appearedTerms.map((term) => {
          return (
            <div>
              <dt>{term.Name}</dt>
              <dd>{term.Description} </dd>
            </div>)
        })}
      </dl>
    </HelpPanel>
  )
}